import { render, staticRenderFns } from "./CoinMessage.vue?vue&type=template&id=77ac5ac6"
import script from "./CoinMessage.vue?vue&type=script&lang=js"
export * from "./CoinMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports